import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const logoSymbolFn = /* @__PURE__ */ createRecipe('logo-symbol', {}, [])

const logoSymbolVariantMap = {}

const logoSymbolVariantKeys = Object.keys(logoSymbolVariantMap)

export const logoSymbol = /* @__PURE__ */ Object.assign(memo(logoSymbolFn.recipeFn), {
  __recipe__: true,
  __name__: 'logoSymbol',
  __getCompoundVariantCss__: logoSymbolFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: logoSymbolVariantKeys,
  variantMap: logoSymbolVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, logoSymbolVariantKeys)
  },
  getVariantProps: logoSymbolFn.getVariantProps,
})